import { GridActionsCellItem, GridCellModes, GridColDef, useGridApiContext } from "@mui/x-data-grid";
import { GridRowModes } from "@mui/x-data-grid";
import { createElement, useMemo } from "react";
import { IconType } from "react-icons/lib";
import { TbEdit, TbX } from "react-icons/tb";

import { HotelClinicListItem } from "@/pages/HotelPlanning/clinic-arrival/types";
import {
    useClinicUnassignedPassengersTableActions,
    useClinicUnassignedRowChanges,
    useClinicUnassignedRowModesModel,
} from "@/stores/use-clinic-arrival-unassigned-passengers-table";

export const ClinicUnassignedActionsColumn = (): GridColDef<HotelClinicListItem> => {
    return {
        field: "actions",
        type: "actions",
        width: 60,
        cellClassName: "!px-2",
        pinnable: true,
        getActions: ({ row: { _isPlaceholder, uniqueIdentifier, cancelled } }) => {
            const rowModesModel = useClinicUnassignedRowModesModel();

            const { handleRowModesModelChange, handleRowModesModelCancel } =
                useClinicUnassignedPassengersTableActions();
            const apiRef = useGridApiContext();
            const rowChanges = useClinicUnassignedRowChanges(uniqueIdentifier);
            const isInEditMode =
                uniqueIdentifier &&
                (rowModesModel[uniqueIdentifier]?.mode === GridRowModes.Edit ||
                    apiRef.current.getCellMode(uniqueIdentifier, "userId") === GridCellModes.Edit);

            const handleEdit = useMemo(() => {
                return () => {
                    handleRowModesModelChange({ ...rowModesModel, [uniqueIdentifier]: { mode: GridRowModes.Edit } });
                };
            }, [uniqueIdentifier, rowModesModel, handleRowModesModelChange]);

            const handleCancel = useMemo(() => {
                return () => {
                    handleRowModesModelCancel(uniqueIdentifier, apiRef.current);
                };
            }, [uniqueIdentifier, apiRef, handleRowModesModelCancel]);

            const actions: {
                label: string;
                icon: IconType;
                color: "primary" | "warning";
                cond: boolean;
                onClick: () => void;
                showInMenu: boolean;
            }[] = useMemo(
                () => [
                    {
                        label: "Güncelle",
                        icon: TbEdit,
                        onClick: handleEdit,
                        cond: !rowChanges && !isInEditMode && !cancelled,
                        color: "primary",
                        showInMenu: false,
                    },
                    {
                        label: "İptal",
                        icon: TbX,
                        onClick: handleCancel,
                        cond: (!!rowChanges || isInEditMode) && !cancelled,
                        color: "warning",
                        showInMenu: false,
                    },
                ],
                [rowChanges, isInEditMode, handleCancel, handleEdit, cancelled]
            );

            if (_isPlaceholder) {
                return [];
            }

            return actions
                .filter((a) => a.cond)
                .map((action) => (
                    <GridActionsCellItem
                        key={action.label}
                        icon={createElement(action.icon, { size: 14 })}
                        label={action.label}
                        onClick={action.onClick}
                        color={action.color}
                        showInMenu={action.showInMenu}
                    />
                ));
        },
    };
};

export default ClinicUnassignedActionsColumn;
